import authReducer from './authReducer';
import notifyReducer from './notifyReducer';
import formReducer from './formReducer';
import tourReducer from './tourReducer';

export default {
    auth: authReducer,
    notifications: notifyReducer,
    formState: formReducer,
    tourState: tourReducer
};
